import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-angola-personal-loan-portuguese.component.scss';
var CalculatorAngolaPersonalLoanPortuguese = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorAngolaPersonalLoanPortuguese, _super);
    function CalculatorAngolaPersonalLoanPortuguese(element) {
        return _super.call(this, element) || this;
    }
    CalculatorAngolaPersonalLoanPortuguese.prototype.init = function () {
        this.varInsuranceRate = 0.55;
        this.varOriginationRate = 2.10;
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInterest = this.element.querySelector('.js-interest-total');
        this.totalTerm = this.element.querySelector('.js-term-total');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        // this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-angola-personal-loan-portuguese__result--terms');
        this.containerSchedule = document.querySelector('.js-amort-schedule-business-loan-calculator-port');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        // if(this.element.getAttribute('data-terms-link')) {
        // 	this.dataTermsLink = this.element.getAttribute('data-terms-link');
        // 	if(this.element.getAttribute('data-terms-text')) {
        // 		this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
        // 	}else{
        // 		this.dataTermsButtonText = "Terms and conditions"
        // 	}		
        // 	this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
        // 	this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
        // 	this.containerTermsAndConditions.classList.remove('d-none');
        // }	
        // if(this.element.getAttribute('data-disclaimer')) {
        // 	this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        // }
        // this.calculate();
        // TooltipsService.initTooltips();
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalMonthly.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
            _this.totalTerm.innerHTML = "-";
        });
        // Format loan amount while typing
        this.inputLoanAmount.addEventListener('input', function (e) {
            e.target.value = _this.formatInputNumber(e.target.value);
        });
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.calculate = function () {
        var amortArray = [];
        var loanAmount = parseFloat(this.inputLoanAmount.value.replace(/\s/g, ''));
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        var month = parseFloat(this.inputTerm.value);
        var totalEstimation = 0;
        var totalInterest = 0;
        for (var index = 0; index < term; index++) {
            // No insurance calculation
            var insuranceRateValue = 0;
            var calcMonthInterest = loanAmount * (interestRate / 1200); // monthly rate
            var calcMonthPrincipal = pmt - calcMonthInterest;
            totalInterest += calcMonthInterest;
            totalEstimation += pmt;
            var lineItem = {
                month: month,
                principal: calcMonthPrincipal,
                interest: calcMonthInterest,
                insurancerate: insuranceRateValue,
                totalPayment: pmt,
                pmt: pmt,
                balance: loanAmount - calcMonthPrincipal,
                totalAccumulated: totalEstimation
            };
            loanAmount -= calcMonthPrincipal;
            month -= 1;
            amortArray.push(lineItem);
        }
        console.log(amortArray);
        this.totalMonthly.innerHTML = this.roundFormatter(totalEstimation / term, 2, true);
        this.totalInterest.innerHTML = this.roundFormatter(totalInterest, 2, true);
        this.totalTerm.innerHTML = term + "meses";
        this.calculateAmort();
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.calculateAmort = function () {
        this.containerSchedule.innerHTML = '';
        var loanAmount = parseFloat(this.inputLoanAmount.value.replace(/\s/g, ''));
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0); // Monthly payment
        var amortArray = [];
        var balance = loanAmount;
        var month = 0;
        var totalInstallment = 0;
        var totalInterest = 0;
        var totalPrincipal = 0;
        var totalStampDuty = 0;
        // Loop exactly for the user-entered term
        for (var i = 0; i < term; i++) {
            month += 1;
            var interest = balance * (interestRate / 100) / 12;
            var principal = pmt - interest;
            var newBalance = balance - principal;
            // Stamp duty calculated as 0.0000002 * balance (rounded to 2 decimals)
            var stampDuty = this.round(interest * 0.00002, 2);
            var lineItem = {
                month: month,
                loanAmount: balance,
                monthlyInstallment: pmt,
                installment: interest,
                stampDuty: stampDuty,
                principal: principal,
                balance: newBalance
            };
            totalInstallment += pmt;
            totalInterest += interest;
            totalPrincipal += principal;
            totalStampDuty += stampDuty;
            amortArray.push(lineItem);
            balance = newBalance;
        }
        // Build output HTML
        var output = "\n\t\t\t<table class=\"table table--blue table-responsive table-striped static_header\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Prazo</th>\n\t\t\t\t\t\t<th>Capital Inicial</th>\n\t\t\t\t\t\t<th>Presta\u00E7\u00E3o</th>\n\t\t\t\t\t\t<th>Imposto de Selo</th>\n\t\t\t\t\t\t<th>Capital Amortizado</th>\n\t\t\t\t\t\t<th>Capital Final</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>";
        for (var _i = 0, amortArray_1 = amortArray; _i < amortArray_1.length; _i++) {
            var row = amortArray_1[_i];
            output += "\n\t\t\t\t<tr>\n\t\t\t\t\t<td>" + row.month + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(row.loanAmount, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(row.installment, 2)) + "</td>\n\t\t\t\t\t<td>" + row.stampDuty.toFixed(2) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(row.principal, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(row.balance, 2)) + "</td>\n\t\t\t\t</tr>";
        }
        output += "\n\t\t\t\t</tbody>\n\t\t\t\t<tfoot>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Total</th>\n\t\t\t\t\t\t<th>-</th>\n\t\t\t\t\t\t<th>" + this.formatter(this.round(totalInstallment, 2)) + "</th>\n\t\t\t\t\t\t<th>" + this.formatter(this.round(totalInterest, 2)) + "</th>\n\t\t\t\t\t\t<th>" + this.formatter(this.round(totalStampDuty, 2)) + "</th>\n\t\t\t\t\t\t<th>" + this.formatter(this.round(totalPrincipal, 2)) + "</th>\n\t\t\t\t\t\t<th>-</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</tfoot>\n\t\t\t</table>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        this.containerSchedule.appendChild(docfragment);
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.formatInputNumber = function (value) {
        var numbersOnly = value.replace(/[^\d]/g, '');
        return numbersOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint));
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.formatter = function (value, decimals) {
        if (decimals === void 0) { decimals = 0; }
        var fixed = parseFloat(value).toFixed(decimals);
        return fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorAngolaPersonalLoanPortuguese.prototype.PMT = function (rate, nper, pv, fv, type) {
        if (fv === void 0) { fv = 0; }
        if (type === void 0) { type = 0; }
        if (rate === 0)
            return -(pv + fv) / nper;
        var pvif = Math.pow(1 + rate, nper);
        var pmt = rate / (pvif - 1) * -(pv * pvif + fv);
        if (type === 1) {
            pmt /= (1 + rate);
        }
        return pmt;
    };
    return CalculatorAngolaPersonalLoanPortuguese;
}(Base));
export { CalculatorAngolaPersonalLoanPortuguese };



//////////////////
// WEBPACK FOOTER
// ./components-angola/calculator-angola-personal-loan-portuguese/calculator-angola-personal-loan-portuguese.component.ts
// module id = 641
// module chunks = 0